import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import type { User } from '@supabase/supabase-js';
import { resolveUserRole } from '../../utils/userRole';
import type { UserRole } from '../../types/user';
import { AdminLoading } from './adminShared';

interface AdminGuardProps {
  user: User | null;
  children: React.ReactNode;
}

const AdminGuard: React.FC<AdminGuardProps> = ({ user, children }) => {
  const [role, setRole] = useState<UserRole | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setRole(null);
      setLoading(false);
      return;
    }

    resolveUserRole(user)
      .then(setRole)
      .finally(() => setLoading(false));
  }, [user]);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <AdminLoading />;
  }

  if (role !== 'superadmin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminGuard;
